import React from 'react';
import PrescriptionDetails from './Components/PrescriptionDetails';

const PrescriptionDetailsPage = () => {
  return (
    <div className="w-full h-full">
      <div className="space-y-8">
        <PrescriptionDetails />
      </div>
    </div>
  );
};

export default PrescriptionDetailsPage;
